<template>
  <div id="learn">
    <!-- 课程浏览走势图 -->
    <div class="course-through">
      <div class="course-title">
        <span>本周</span>
        <span>月度</span>
        <span>年度</span>
      </div>
      <div class="course-main">
        <div class="main-left"><span>课程浏览走势图</span></div>
        <div class="main-right">
          <div class="Echarts">
            <div id="main" style="width: 1000px; height: 260px"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 切片浏览走势图 -->
    <div class="section-through">
      <div class="section-title">
        <span>本周</span>
        <span>月度</span>
        <span>年度</span>
      </div>
      <div class="section-main">
        <div class="main-left"><span>切片浏览走势图</span></div>
        <div class="main-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts/lib/echarts";
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById("main"));
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["qwe"],
          x: "left",
        },
        color: ["#0080ff"],
        grid: {
          left: "5%",
          right: "10%",
          top:"5%",
          bottom: "40%",
          // containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: ["0", "20", "40", "60", "80"],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "浏览次数",
            type: "line",
            stack: "总量",
            smooth: true,
            itemStyle: {
              normal: {
                //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#2EADB5", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#c9eaec", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#fff", // 100% 处的颜色
                  },
                ]), //背景渐变色
                lineStyle: {
                  // 系列级个性化折线样式
                  width: 3,
                  type: "solid",
                  color: "#4fd6d2",
                },
              },
              emphasis: {
                color: "#4fd6d2",
                lineStyle: {
                  // 系列级个性化折线样式
                  width: 2,
                  type: "dotted",
                  color: "#4fd6d2", //折线的颜色
                },
              },
            }, //线条样式
            symbolSize: 5, //折线点的大小
            areaStyle: { normal: {} },
            data: [320, 332, 601, 134, 120],
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
  mounted() {
    this.myEcharts();
  },
};
</script>


<style lang="less" scoped>
#learn {
  width: 100%;
  height: 100%;
  // background-color: #ff6700;
  padding: 1.6% 12% 0 2%;
  .course-through {
    width: 100%;
    height: 50%;
    .course-title {
      display: flex;
      justify-content: flex-end;
      height: 12%;
      span {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #9ea5bd;
        cursor: pointer;
        margin-right: 3%;
        &:hover {
          // color: #38456b;
          border-bottom: 3px solid #2eadb5;
        }
      }
    }
    .course-main {
      display: flex;
      width: 100%;
      height: 80%;
      .main-left {
        display: flex;
        align-items: center;
        width: 10%;
        height: 100%;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #333e5f;
      }
      .main-right {
        width: 90%;
        height: 100%;
      }
    }
  }
  .section-through {
    width: 100%;
    height: 50%;
    .section-title {
      display: flex;
      justify-content: flex-end;
      height: 12%;
      span {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #9ea5bd;
        cursor: pointer;
        margin-right: 3%;
        &:hover {
          // color: #38456b;
          border-bottom: 3px solid #2eadb5;
        }
      }
    }
    .section-main {
      display: flex;
      width: 100%;
      height: 80%;
      // background-color: #333;
      .main-left {
        display: flex;
        align-items: center;
        width: 10%;
        height: 100%;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #333e5f;
        // background-color: #555;
      }
      .main-right {
        width: 90%;
        height: 100%;
      }
    }
  }
}
</style>